import { createContext, useContext } from 'react';
import { LayoutOption } from '../LayoutOption';
export var LayoutContext = createContext({
    currentLayout: LayoutOption.List,
    setCurrentLayout: null,
});
export var useLayoutContext = function () {
    var context = useContext(LayoutContext);
    var setCurrentLayout = context.setCurrentLayout;
    if (!context && !setCurrentLayout) {
        throw new Error("LayoutSwitch compound components cannot be rendered outside the LayoutSwitch component");
    }
    return context;
};
//# sourceMappingURL=useLayoutContext.js.map